/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnreadFaxCountResponse
 */
export interface UnreadFaxCountResponse {
    /**
     * Number of unread faxes in the given scope
     * @type {number}
     * @memberof UnreadFaxCountResponse
     */
    count: number;
}

/**
 * Check if a given object implements the UnreadFaxCountResponse interface.
 */
export function instanceOfUnreadFaxCountResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function UnreadFaxCountResponseFromJSON(json: any): UnreadFaxCountResponse {
    return UnreadFaxCountResponseFromJSONTyped(json, false);
}

export function UnreadFaxCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnreadFaxCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function UnreadFaxCountResponseToJSON(value?: UnreadFaxCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}

